import { useState, useEffect } from 'react';
import api from '../services/api';

const useFooterConfig = () => {
    const [footerConfig, setFooterConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchConfig = async () => {
        try {
            const response = await api.get('/settings/footer_config');
            console.log("DEBUG: useFooterConfig response raw:", response.data);
            
            const extractValue = (data) => {
                if (data === null || data === undefined) return null;
                if (typeof data !== 'object') return data;

                if (Array.isArray(data)) {
                    const isKV = data.length > 0 && data.every(item => 
                        item && typeof item === 'object' && 
                        (('Key' in item && 'Value' in item) || ('key' in item && 'value' in item))
                    );

                    if (isKV) {
                        return data.reduce((acc, item) => {
                            const k = (item.Key || item.key)?.toLowerCase();
                            const v = item.Value !== undefined ? item.Value : item.value;
                            if (k) acc[k] = extractValue(v); 
                            return acc;
                        }, {});
                    }
                    return data.map(extractValue);
                }

                if (data.value !== undefined) return extractValue(data.value);
                if (data.Value !== undefined) return extractValue(data.Value);
                
                return Object.keys(data).reduce((acc, key) => {
                    acc[key.toLowerCase()] = extractValue(data[key]);
                    return acc;
                }, {});
            };

            const config = extractValue(response.data);
            if (config) {
                console.log("DEBUG: useFooterConfig extracted:", config);
                setFooterConfig(config);
            }
        } catch (error) {
            console.error('Error fetching footer config:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchConfig();
        
        // Listen for a custom event to re-fetch when Admin updates
        const handleUpdate = () => fetchConfig();
        window.addEventListener('footer_config_updated', handleUpdate);
        
        return () => window.removeEventListener('footer_config_updated', handleUpdate);
    }, []);

    return { footerConfig, loading, refresh: fetchConfig };
};

export default useFooterConfig;
